module.exports = __webpack_public_path__ + "static/img/banner.14980f50.jpg";